/* globals Knitiv */

export default class NotificationController {
	/** @type {Knitiv.RootScope} */
	$rootScope;

	/* @ngInject */
	/**
	 * @param {Knitiv.RootScope} $rootScope
	 * @param {any} $copyToClipboard
	 */
	constructor($rootScope, $copyToClipboard) {
		this.$rootScope = $rootScope;
		this.$copyToClipboard = $copyToClipboard;
	}

	// eslint-disable-next-line class-methods-use-this
	/**
	 * @param {MouseEvent} event
	 */
	click(event) {
		event.preventDefault();
		event.stopImmediatePropagation();
	}

	/**
	 * @param {KeyboardEvent} event
	 * @param {number} index
	 */
	copy(event, index) {
		const notification = this.$rootScope.notificationHistory[index];
		this.$copyToClipboard(
			notification.message,
			true,
			() => 'Message copié dans le presse-papiers !',
			{
				addToHistory: false,
			},
		);
	}

	/**
	 * @param {KeyboardEvent} event
	 * @param {number} index
	 */
	remove(event, index) {
		event.preventDefault();
		event.stopImmediatePropagation();
		this.$rootScope.notificationHistory.splice(index, 1);
	}
}
